import { useContext } from "react";
import { MixpanelContext } from "../contexts/MixpanelContext";

// ----------------------------------------------------------------------

const useMixpanel = () => {
  let context = useContext(MixpanelContext);

  if (context.mixpanel) {
    return context;
  } else {
    return {
      mixpanel: {
        track: () => {
          //console.log("fake mixpanel track");
        },
        init: () => {
          //console.log("fake mixpanel init");
        },
        people: { set: () => {} },
        identify: () => {
          //console.log("fake mixpanel identify");
        },
      },
    };
  }
};

export default useMixpanel;
